var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGlassesLight = function SvgGlassesLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 38,
    viewBox: "0 0 103 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3911 27.9998C25.2274 26.7989 26.1608 25.7296 27.3728 25.7296H40.0815C41.1861 25.7296 42.0815 26.625 42.0815 27.7296V34.7296C42.0815 35.8341 41.1861 36.7296 40.0815 36.7296H28.3273C27.3272 36.7296 26.4808 35.9908 26.3457 34.9998L25.3911 27.9998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.772 27.9998C76.9357 26.7989 76.0023 25.7296 74.7903 25.7296H62.0815C60.977 25.7296 60.0815 26.625 60.0815 27.7296V34.7296C60.0815 35.8341 60.977 36.7296 62.0815 36.7296H73.8358C74.8359 36.7296 75.6823 35.9908 75.8174 34.9998L76.772 27.9998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0815 31.7296C38.0815 31.7296 45.6033 29.2296 50.5815 29.2296C55.5598 29.2296 63.0815 31.7296 63.0815 31.7296",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0815 28.2675L5.08154 3.2675C4.91488 2.7675 3.88154 2.1675 1.08154 3.7675",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0815 27.2675L97.0815 2.2675C97.2482 1.7675 98.2815 1.1675 101.082 2.7675",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.333 34.1134C48.333 35.3653 49.4254 36.4581 50.8719 36.4581C52.3185 36.4581 53.4109 35.3653 53.4109 34.1134H54.9394C54.9394 36.2955 53.074 37.9866 50.8719 37.9866C48.6698 37.9866 46.8044 36.2955 46.8044 34.1134H48.333Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlassesLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/glasses_light.5434a154.svg";
export { ForwardRef as ReactComponent };